import React from "react";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AddIcon from "@mui/icons-material/Add";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import SearchData from "../components/SearchData";
import { DataGrid } from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});

export default function AddExpense() {
  const history = useHistory();

  const [customer_id, setCustomer_id] = useState("");

  const [customer_data, setCustomer_data] = useState([]);
  const [quotation_fetch_data, setQuotation_fetch_data] = useState([]);
  const [expense_data, setExpense_data] = useState("");
  let { id } = useParams();
  const data_params = { id: id };
  const EmpId = localStorage.getItem("EmpId");

  const [detail_data, setDetail_data] = useState([]);
  const [dialog_ref_so, setDialog_ref_so] = useState("");
  const [quotation_no, setQuotation_no] = useState("");
  const [dialog_Expdate, setDialog_Expdate] = useState("");
  const [dialog_Type, setDialog_Type] = useState("");
  const [dialog_open, setDialog_open] = useState(false);
  const [dialog_charge, setDialog_charge] = useState("");
  const [dialog_amount, setDialog_amount] = useState("");
  const [have_id, setHave_id] = useState(false);
  //fetch Customer Data

  const getCustomer_Data = async () => {
    const params = {
      cusType: 2,
    };
    try {
      const data = await api.post("api/customer/list", params);
      //   console.log(data.data);
      setCustomer_data(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getExpense_Data = async () => {
    try {
      const data = await api.post("/api/financial/expense/detail", data_params);
      data.data.map((res) => {
        setExpense_data(res);

        setDetail_data(res.Detail);
      });
    } catch (e) {
      console.log(e);
    }
  };

  //fetch Quotation By id
  const GetQuotation = async (props, data) => {
    if (data !== null && data !== undefined) {
      const id = {
        id: data.CustomerId,
      };
      setCustomer_id(data.CustomerId);
      try {
        const data = await api.post("api/master/referquotation", id);
        // console.log(data.data.data);
        setQuotation_fetch_data(data.data.data);
      } catch (e) {
        console.log(e);
      }

      //   console.log(customer_id);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getCustomer_Data();
    if (id) {
      getExpense_Data();
      setHave_id(true);
    }
  }, []);

  const confirm_detail = () => {
    if (
      dialog_Expdate !== "" &&
      dialog_charge !== "" &&
      dialog_Type !== "" &&
      dialog_amount !== "" &&
      quotation_no !== ""
    ) {
      const data = {
        expDate: dialog_Expdate,
        charge: dialog_charge,
        description: dialog_Type,
        amount: dialog_amount,
        invoiceNo: quotation_no,
      };
      setDetail_data([...detail_data, data]);
      setDialog_open(false);
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };
  const delete_Detail = (data) => {
    detail_data.splice(data, 1);
    setDetail_data([...detail_data]);
    // console.log(MT_CNTR_AT_CY_STL_DATA);
  };

  const classes = useStyles();

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Expense
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">
                Financial / Expense
              </Typography>
              <Typography>
                <span>&nbsp;</span> / {id ? "Detail" : "Add"} Expense
              </Typography>
            </Grid>
          </Grid>

          <Formik
            enableReinitialize={have_id}
            initialValues={{
              expNo: expense_data?.expNo ? expense_data?.expNo : "",
              expDate: expense_data?.ExpenseDate
                ? expense_data?.ExpenseDate
                : "",
              refQuotation: expense_data?.RefQuotationNo
                ? expense_data?.RefQuotationNo
                : "",
              quotation_no: "",
              charge: expense_data?.Charge ? expense_data?.Charge : "",
              cusId: expense_data?.CustomerId ? expense_data?.CustomerId : "",
              description: expense_data?.Description
                ? expense_data?.Description
                : "",
              amount: expense_data?.Amount ? expense_data?.Amount : "",
              invDate: expense_data?.InvDate
                ? expense_data?.InvDate
                : new Date(),
              invRefno: expense_data?.InvRefNo ? expense_data?.InvRefNo : "",
              invAmount: expense_data?.InvAmount ? expense_data?.InvAmount : "",
              revDate: expense_data?.RevDate ? expense_data?.RevDate : "",
              revRefNo: expense_data?.RevRefNo ? expense_data?.RevRefNo : "",
              revAmount: expense_data?.RevAmount ? expense_data?.RevAmount : "",
              status: expense_data?.Status ? expense_data?.Status : "",
              soref: expense_data?.refSo ? expense_data?.refSo : "",
              approve: expense_data?.Approve ? expense_data?.Approve : "",
              EmpApprove: expense_data?.EmpApproveId
                ? expense_data?.EmpApproveId
                : "",
              createId: "",
              ship: expense_data?.shippingRef ? expense_data?.shippingRef : "",
              detail: expense_data?.Detail ? expense_data?.Detail : "",
            }}
            validate={(values) => {
              const errors = {};
              if (!id) {
                if (!customer_id || values.customer_id === "") {
                  errors.customer_id = " * Required";
                }
                if (!detail_data < 0) {
                  alert("กรุณากรอกข้อมูลให้ครบถ้วน");
                }
                // if (!values.soref || values.soref === "") {
                //   errors.soref = " * Required";
                // }
                // if (!values.ship || values.ship === "") {
                //   errors.ship = " * Required";
                // }

                //   if (!values.description || values.description === "") {
                //     errors.description = " * Required";
                //   }
                //   if (!values.amount || values.amount === "") {
                //     errors.amount = " * Required";
                //   }
                //   if (!values.invDate || values.invDate === "") {
                //     errors.invDate = " * Required";
                //   }
                //   if (!values.invRefno || values.invRefno === "") {
                //     errors.invRefno = " * Required";
                //   }
                //   if (!values.invAmount || values.invAmount === "") {
                //     errors.invAmount = " * Required";
                //   }
                //   if (!values.revDate || values.revDate === "") {
                //     errors.revDate = " * Required";
                //   }
                //   if (!values.revRefNo || values.revRefNo === "") {
                //     errors.revRefNo = " * Required";
                //   }
                //   if (!values.revAmount || values.revAmount === "") {
                //     errors.revAmount = " * Required";
                //   }
              }

              console.log(errors);
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                if (id) {
                  const data = {
                    id: id,
                    // expDate: values.expDate,
                    // refQuotation: expense_data?.RefQuotationNo,
                    refSo: values.soref,
                    shippingRef: values.ship,
                    expNo: expense_data?.expNo, // charge: values.charge,
                    cusId: expense_data?.CustomerId,
                    // description: values.description,
                    // amount: values.amount,
                    // invDate: values.invDate,
                    // invRefno: values.invRefno,
                    // invAmount: values.invAmount,
                    // revDate: values.revDate,
                    // revRefNo: values.revRefNo,
                    // revAmount: values.revAmount,

                    ModId: EmpId,
                    detail: detail_data,
                  };

                  // console.log(data);
                  if (detail_data.length > 0) {
                    api
                      .post("api/financial/expense/update", data)
                      .then((respose) => {
                        const MySwal = withReactContent(Swal);

                        MySwal.fire({
                          icon: "success",
                          didOpen: () => {
                            MySwal.clickConfirm();
                          },
                        }).then(() => {
                          return MySwal.fire(
                            "สำเร็จ!",
                            "แก้ไข Expense สำเร็จ !",
                            "success"
                          ).then((result) => {
                            if (result.isConfirmed) {
                              // history.push("/Financial/Expense");
                              getExpense_Data();
                            }
                          });
                        });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  } else {
                    alert("ใส่ข้อมูลให้ครบ");
                  }
                } else {
                  const data = {
                    // // expDate: values.expDate,
                    // refQuotation: values.quotation_no,
                    refSo: values.soref ? values.soref : "",
                    shippingRef: values.ship ? values.ship : "",
                    // charge: values.charge,
                    cusId: customer_id,

                    // description: values.description,
                    // amount: values.amount,
                    // invDate: values.invDate,
                    // invRefno: values.invRefno,
                    // invAmount: values.invAmount,
                    // revDate: values.revDate,
                    // revRefNo: values.revRefNo,
                    // revAmount: values.revAmount,
                    status: 1,
                    createId: EmpId,
                    detail: detail_data,
                  };

                  if (detail_data.length > 0) {
                    api
                      .post("api/financial/expense/create", data)
                      .then((respose) => {
                        const MySwal = withReactContent(Swal);

                        MySwal.fire({
                          icon: "success",
                          didOpen: () => {
                            MySwal.clickConfirm();
                          },
                        }).then(() => {
                          return MySwal.fire(
                            "สำเร็จ!",
                            "เพิ่ม Expense สำเร็จ !",
                            "success"
                          ).then((result) => {
                            if (result.isConfirmed) {
                              history.push("/Financial/Expense");
                            }
                          });
                        });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  } else {
                    alert("ใส่ข้อมูลให้ครบ");
                  }
                }
                // alert(JSON.stringify(values, null, 2));
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              /* and other goodies */
            }) => (
              <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                <Grid
                  item
                  xs={12}
                  sx={{ justifyContent: "right", display: "flex" }}
                >
                  {id ? (
                    <h4 className="textcolorgreen">
                      #{expense_data?.expNo} ||{" "}
                      {expense_data?.Approve == 1
                        ? "APPROVE"
                        : "WAIT FOR APPROVE"}
                    </h4>
                  ) : null}
                </Grid>

                <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                  CUSTOMER <font color="red">*</font>
                </h6>

                <div>
                  {id ? (
                    <div style={{ display: "flex" }}>
                      <TextField
                        name="customer"
                        label="CUSTOMER NAME"
                        variant="outlined"
                        placeholder="CUSTOMER NAME"
                        disabled
                        onBlur={handleBlur}
                        style={{ width: "100%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          expense_data?.CustomerName
                            ? expense_data?.CustomerName
                            : ""
                        }
                      />
                      {/* <TextField
                        name="refQuotation"
                        label="Refer Quotation no."
                        variant="outlined"
                        disabled
                        placeholder="Refer Quotation no."
                        onBlur={handleBlur}
                        onChange={handleChange}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          expense_data?.RefQuotationNo
                            ? expense_data?.RefQuotationNo
                            : ""
                        }
                      /> */}
                    </div>
                  ) : (
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={customer_data}
                      getOptionLabel={(option) => option.CustomerName}
                      onChange={(x, y) => GetQuotation(x, y)}
                      renderInput={(params) => (
                        <TextField
                          name="customer_name"
                          label="CUSTOMER NAME"
                          variant="outlined"
                          placeholder="Customer Name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          InputLabelProps={{ shrink: true }}
                          value={values.customer_name}
                          classes={{ root: classes.customOutline }}
                          {...params}
                          fullWidth
                        />
                      )}
                    />
                  )}
                </div>
                <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                  Refer no
                </h6>
                <div style={{ display: "flex" }}>
                  <TextField
                    name="soref"
                    label="REF SO NO"
                    variant="outlined"
                    placeholder="REF SO NO"
                    disabled={expense_data?.Approve == 1}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    style={{ width: "50%", marginRight: 5 }}
                    InputLabelProps={{ shrink: true }}
                    value={values.soref}
                  />
                  <TextField
                    name="ship"
                    label="SHIPPER REF NO."
                    variant="outlined"
                    disabled={expense_data?.Approve == 1}
                    placeholder="SHIPPER REF NO."
                    onBlur={handleBlur}
                    onChange={handleChange}
                    style={{ width: "50%", marginRight: 5 }}
                    InputLabelProps={{ shrink: true }}
                    value={values.ship}
                  />
                </div>
                <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                  Expense Detail
                </h6>

                <Grid container>
                  <Grid item xs={12} md={12}>
                    <div style={{ display: "flex", marginTop: 20 }}>
                      {expense_data?.Approve != 1 ? (
                        <Button
                          type="button"
                          variant="contained"
                          style={{
                            background: "#80c340",
                            borderColor: "#80c340",
                            marginLeft: "10px",
                          }}
                          onClick={() => setDialog_open(true)}
                        >
                          <AddIcon /> Add Row
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                    {/* <div style={{ display: "flex", marginTop: 20 }}> */}

                    {/* {id ? (
                        <TextField
                          name="expNo"
                          label="EXP NO"
                          variant="outlined"
                          placeholder="EXP NO"
                          disabled
                          onBlur={handleBlur}
                          onChange={handleChange}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={
                            expense_data?.ExpenseNo
                              ? expense_data?.ExpenseNo
                              : ""
                          }
                        />
                      ) : null}

                      <TextField
                        name="expDate"
                        label="EXP DATE"
                        type="date"
                        value={values.expDate}
                        variant="outlined"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        classes={{ root: classes.customOutline }}
                        InputLabelProps={{ shrink: true }}
                      />

                      {!id ? (
                        <FormControl
                          sx={{ width: "50%", marginRight: "5px" }}
                          classes={{ root: classes.customOutline }}
                        >
                          <InputLabel>
                            Refer Quotation no. <font color="red">*</font>
                          </InputLabel>
                          <Select
                            name="quotation_no"
                            value={
                              values.quotation_no ? values.quotation_no : ""
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            label="Refer Quotation no."
                          >
                            <MenuItem value="" disabled>
                              <em>กรุณาค้นหา CustomerName </em>
                            </MenuItem>
                            {quotation_fetch_data.map((option, index) => {
                              return (
                                <MenuItem
                                  key={index}
                                  value={option.QuotationNo}
                                >
                                  {option.QuotationNo}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      ) : null}

                      <FormControl
                        sx={{ width: "50%", marginRight: "5px" }}
                        classes={{ root: classes.customOutline }}
                      >
                        <InputLabel>CHARGE</InputLabel>
                        <Select
                          name="charge"
                          value={values.charge ? values.charge : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          label="Refer Quotation no."
                        >
                          <MenuItem value="ex">
                            <em>EX-CHARGE</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="description"
                        label="รายละเอียด"
                        variant="outlined"
                        placeholder="รายละเอียด"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.description}
                        classes={{ root: classes.customOutline }}
                      />
                      {errors.description &&
                        touched.description &&
                        errors.description}
                      <TextField
                        name="amount"
                        label="จำนวนเงิน"
                        variant="outlined"
                        placeholder="จำนวนเงิน"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.amount}
                        classes={{ root: classes.customOutline }}
                      />
                      {errors.amount && touched.amount && errors.amount}
                    </div> */}
                    {/* <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="invDate"
                        label="INV DATE"
                        type="date"
                        variant="outlined"
                        onChange={handleChange}
                        placeholder="invDate"
                        onBlur={handleBlur}
                        style={{ width: "25%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.invDate}
                        classes={{ root: classes.customOutline }}
                      />

                      <TextField
                        name="invRefno"
                        label="INV Ref No."
                        type="number"
                        variant="outlined"
                        placeholder="invRefno"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        style={{ width: "25%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.invRefno}
                        classes={{ root: classes.customOutline }}
                      />

                      <TextField
                        name="invAmount"
                        type="number"
                        label="INV AMT"
                        variant="outlined"
                        placeholder="invAmount"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.invAmount}
                        classes={{ root: classes.customOutline }}
                      />
                    </div>
                    <div style={{ display: "flex", marginTop: 10 }}>
                      <TextField
                        name="revDate"
                        label="Rev DATE"
                        type="date"
                        variant="outlined"
                        placeholder="revDate"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        style={{ width: "25%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.revDate}
                        classes={{ root: classes.customOutline }}
                      />

                      <TextField
                        name="revRefNo"
                        label="Rev Ref No."
                        type="number"
                        variant="outlined"
                        placeholder="revRefNo"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        style={{ width: "25%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.revRefNo}
                        classes={{ root: classes.customOutline }}
                      />

                      <TextField
                        name="revAmount"
                        type="number"
                        label="Rev AMT"
                        variant="outlined"
                        placeholder="revAmount"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ width: "50%", marginRight: 5 }}
                        InputLabelProps={{ shrink: true }}
                        value={values.revAmount}
                        classes={{ root: classes.customOutline }}
                      />
                    </div> */}

                    {/* <hr /> */}
                    <div style={{ display: "flex", marginTop: 10 }}>
                      {/* <h6
                        style={{ marginTop: "10px" }}
                        className="textcolordarkblue"
                      >
                        Refer so
                      </h6> */}
                      {/* <Button
                        type="button"
                        variant="contained"
                        style={{
                          background: "#80c340",
                          borderColor: "#80c340",
                          marginLeft: "10px",
                        }}
                        onClick={() => setDialog_open(true)}
                      >
                        <AddIcon /> Add Row
                      </Button> */}
                    </div>
                    {detail_data.length > 0 ? (
                      <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">#</TableCell>
                              <TableCell align="center">Exp date </TableCell>
                              <TableCell align="center">Charge</TableCell>
                              <TableCell align="center">description</TableCell>
                              <TableCell align="center">invoiceNo</TableCell>
                              <TableCell align="center">Amount</TableCell>
                              <TableCell align="center"></TableCell>
                            </TableRow>
                          </TableHead>
                          {detail_data.map((data, index) => {
                            return (
                              <TableBody>
                                <TableCell align="center">
                                  {index + 1}
                                </TableCell>
                                <TableCell align="center" width="15%">
                                  {moment(data.expDate).format("DD-MM-YYYY")}
                                </TableCell>
                                <TableCell align="center" width="15%">
                                  {data.charge === "1"
                                    ? "EX-CHARGE"
                                    : "ADVANCE PAYMENT"}
                                </TableCell>
                                <TableCell align="right" width="15%">
                                  {data.description}
                                </TableCell>
                                <TableCell align="right" width="15%">
                                  {data.invoiceNo}
                                </TableCell>
                                <TableCell align="right" width="15%">
                                  {data.amount}
                                </TableCell>
                                <TableCell align="right" width="15%">
                                  <Button
                                    disabled={expense_data?.Approve == 1}
                                    onClick={() => delete_Detail(index)}
                                  >
                                    Delete
                                  </Button>
                                </TableCell>
                              </TableBody>
                            );
                          })}
                        </Table>
                      </TableContainer>
                    ) : null}
                    <hr />
                  </Grid>
                </Grid>
                <div style={{ display: "flex", marginTop: 10 }}>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={history.goBack}
                  >
                    Back
                  </Button>

                  {expense_data?.Approve == 0 ? (
                    <Button
                      type="submit"
                      variant="contained"
                      style={{
                        background: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                      }}
                      disabled={isSubmitting}
                    >
                      {isSubmitting && <CircularProgress size={22} />}
                      {!isSubmitting && "SAVE"}
                    </Button>
                  ) : null}
                  {expense_data?.Approve == 0 ? (
                    <Button
                      sx={{ width: 80 }}
                      // type="submit"
                      variant="contained"
                      style={{
                        background: "#30318D",
                        borderColor: "#30318D",
                        marginRight: "10px",
                      }}
                      onClick={() => {
                        const params = {
                          id: id,
                          approve: 1,
                          ModId: EmpId,
                        };
                        api
                          .post("api/financial/expense/approve", params)
                          .then((respose) => {
                            const MySwal = withReactContent(Swal);

                            MySwal.fire({
                              icon: "success",
                              didOpen: () => {
                                MySwal.clickConfirm();
                              },
                            }).then(() => {
                              return MySwal.fire(
                                "สำเร็จ!",
                                "อนุมัติรายการสำเร็จ !",
                                "success"
                              ).then((result) => {
                                if (result.isConfirmed) {
                                  // console.log(respose.data.id);
                                  // history.push(
                                  //   "/ContainerRepair/Repair/Edit/" + id
                                  // );
                                  getExpense_Data();

                                  // history.push("/ContainerRepair/RepairList");
                                }
                              });
                            });
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }}
                      // disabled={Submitting}
                    >
                      {isSubmitting && <CircularProgress size={22} />}
                      {!isSubmitting && "Approve"}
                    </Button>
                  ) : null}
                </div>
              </form>
            )}
          </Formik>
        </Card>
      </LocalizationProvider>
      <Dialog
        open={dialog_open}
        onClose={() => setDialog_open(false)}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
      >
        <DialogTitle id="responsive-dialog-title">
          {
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              ADD ROW
            </Typography>
          }
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* <h5 className="textcolordarkblue">Add row</h5> */}
          </DialogContentText>

          <Grid item xs>
            <TextField
              name="dialog_Expdate"
              label="invoice date"
              type="date"
              onChange={(e) => setDialog_Expdate(e.target.value)}
              variant="outlined"
              style={{ width: "100%", marginRight: 5, marginTop: "5px" }}
              classes={{ root: classes.customOutline }}
              InputLabelProps={{ shrink: true }}
              value={dialog_Expdate}
            />
          </Grid>
          <Grid item xs>
            <TextField
              name="refQuotation"
              label="invoiceNo."
              variant="outlined"
              placeholder="invoice No"
              style={{ width: "100%", marginRight: 5, marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              value={quotation_no}
              onChange={(e) => setQuotation_no(e.target.value)}
            />
          </Grid>
          <Grid item xs>
            <FormControl
              sx={{ width: "100%", marginRight: "5px", marginTop: "5px" }}
              // classes={{ root: classes.customOutline }}
            >
              <InputLabel>CHARGE</InputLabel>
              <Select
                name="dialog_charge"
                value={dialog_charge}
                onChange={(e) => setDialog_charge(e.target.value)}
                label="Refer Quotation no."
              >
                <MenuItem value="1">EX-CHARGE</MenuItem>
                <MenuItem value="2">ADVANCE PAYMENT</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs>
            {/* <FormControl
              sx={{ width: "100%", marginRight: "5px", marginTop: "5px" }}
              classes={{ root: classes.customOutline }}
            >
              <InputLabel>
                Refer Quotation no. <font color="red">*</font>
              </InputLabel>
              <Select
                name="quotation_no"
                onChange={(e) => setQuotation_no(e.target.value)}
                label="Refer Quotation no."
                value={quotation_no}
              >
                <MenuItem value="" disabled>
                  <em>กรุณาค้นหา CustomerName </em>
                </MenuItem>
                {quotation_fetch_data.map((option, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={option.QuotationNo}
                    >
                      {option.QuotationNo}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl> */}
          </Grid>
          <Grid item xs>
            <TextField
              name="dialog_type"
              label="description"
              variant="outlined"
              style={{
                width: "100%",
                marginTop: "10px",
                marginBottom: "10px",
              }}
              onChange={(e) => setDialog_Type(e.target.value)}
              InputLabelProps={{ shrink: true }}
              value={dialog_Type}
            />
          </Grid>
          <Grid item xs>
            <TextField
              name="dalog_amount"
              label="amount"
              variant="outlined"
              style={{
                width: "100%",
                marginTop: "5px",
                marginBottom: "10px",
              }}
              onChange={(e) => setDialog_amount(e.target.value)}
              InputLabelProps={{ shrink: true }}
              value={dialog_amount}
            />
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            sx={{ width: 80 }}
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={() => setDialog_open(false)}
          >
            close
          </Button>
          <Button
            sx={{ width: 80 }}
            type="submit"
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            //   disabled={Submitting}
            onClick={() => confirm_detail()}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
